import { Component, EventEmitter, HostListener, Input, OnInit, Optional, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { PlainResultModalComponent } from '../../../../../../shared/components/plain-result-modal/plain-result-modal.component';
import { StringHelper } from '../../../../../../core/helpers/strings.helper';
import { TransferService } from '../../../../../../core/services/transfer.service';
import { BaseFormComponent } from '../../../../../../lean-shared/components/base-form/base-form.component';
import { ModalOptionsConfig, ModalService } from '../../../../nz-modal-service/modal.service';
import { DialogMessageType } from '../../../../../../shared/models/utility.model';
import { BeneficiaryBankDetailsComponent } from '../beneficiary-bank-details/beneficiary-bank-details.component';
import { DEFAULT_DIALOG_CLASSES, MONIEPOINT_DESIGN_TYPE } from '../../../../../../shared/constants';
import { MoniepointBeneficiaryModel, TransferRequestModal } from '../../../../../../shared/models/transfer.model';
import { CustomFormControl, CustomFormControlDefinition } from '../../../../../../shared/utils/custom-form-control';
import { AddBeneficiaryComponent } from './add-beneficiary/add-beneficiary.component';

@Component({
	selector: 'app-manage-beneficiaries',
	templateUrl: './manage-beneficiaries.component.html',
	styleUrls: ['./manage-beneficiaries.component.scss']
})
export class ManageBeneficiariesComponent extends BaseFormComponent implements OnInit {

	searchParams: string;
	customerSearchParam: string;
	@Input() beneficiaries: MoniepointBeneficiaryModel[] = [];
	@Input() variant: string;
	@Input() transferRequest: TransferRequestModal;
	@Output() selectedBeneficiaryEmmiter = new EventEmitter();
	@Output() backEmmiter = new EventEmitter();
	selectedBeneficiaryItem: MoniepointBeneficiaryModel;
	breakPoint = 900;
	isMobile = false;
	MANAGE_BENEFICIARIES = 1;
	ADD_BENEFICIARY = 2;
	BENEFICIARY_SUMMARY = 3;
	currentStep = this.MANAGE_BENEFICIARIES;
	modalConfig: any;
	runningModal: any;
	accountNoControl: CustomFormControlDefinition;
	beneficiaryDetails: any;
	accountNo: any;
	error_message: string;

	constructor(@Optional() private modalService: NzModalRef, private fb: FormBuilder, public modal: ModalService,
		private transferService: TransferService) {
		super(fb);
		this.transferService._goToManageBeneficiary$.subscribe(() => {
			this.goBack();
		})
	}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

	ngOnInit(): void {
		this.accountNoControl = new CustomFormControl()
			.id('account_no')
			.placeholder('Enter Account Number')
			.name('account_no')
			.minLength(10)
			.maxLength(10)
			.isAccountNumber()
			.isRequired()
			.build();

		this.form = this.fb.group({
			accountNo: this.accountNoControl.formGroupControl,
		});
		this.setMobile(window.innerWidth);
	}

	selectedBeneficiary(beneficiary) {
		this.selectedBeneficiaryItem = beneficiary;
	}

	getInitials(beneficiaryName: string) {
		if (beneficiaryName) {
			let initials = '';
			const fullName = beneficiaryName.split(' ');
			for (const item of fullName) {
				if (initials.length === 2) {
					break;
				}
				initials += item.charAt(0);
			}
			return initials.toUpperCase();
		} else {
			return '';
		}
	}

	closeModal() {
		this.modalService.destroy();
	}

	goBack() {
		this.backEmmiter.emit();
	}

	openBanksForm() {
		const configObj = {
			amount: this.transferRequest?.amount || 0,
			accountNumber: this.form?.value?.accountNo || "1234567889",
			context: 'DEPOSIT',
			contractCode: this.transferRequest?.contractCode,
			isMobile: this.isMobile,
			btnText: 'Confirm',
			addBeneficiary: true
		};
		this.modalConfig = {
			amount: this.transferRequest?.contractCode,
			accountNumber: this.form?.value?.accountNo
		};
		const config = this.createModalConfig(configObj);
		config.className = 'moniepoint-dialog';
		this.runningModal = this.modal.createModal(BeneficiaryBankDetailsComponent, config);
	}

	createModalConfig(data?) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = data;
		config.nzMaskClosable = true;
		config.nzComponentParams.callback = (result) => {
			this.saveBeneficiaryDetails(result);
		};
		return config;
	}

	saveBeneficiaryDetails(details) {
		if (details) {
			this.beneficiaryDetails = {
				accountNo: this.form?.value?.accountNo,
				recipientAccountName: details?.account?.name,
				recipientBankCode: details?.bankCode,
				recipientBankCbnCode: details?.recipientBankCbnCode,
				contractCode: details?.contractCode,
				bankName: details.bankName,
				variant: this.variant,
				fee: details.fee,
				saveBeneficiary: details.saveBeneficiary,
				nameEnquiryCacheReference: details?.account?.nameEnquiryCacheReference,
			};
			this.currentStep = this.BENEFICIARY_SUMMARY;
			this.runningModal.destroy();
		} else {
			this.runningModal.destroy();
		}
	}

	cancelBeneficiary() {
		this.currentStep = this.MANAGE_BENEFICIARIES
		this.form.get('accountNo').patchValue('');
		this.form.markAsPristine();
		this.form.markAsUntouched();
		// this.accountNoControl.formGroupControl.reset();
	}

	launchAddBeneficiaryModal() {
		const config = new ModalOptionsConfig();
		config.nzClosable = false;
		config.nzMaskClosable = true;
		config.nzComponentParams.data = {};
		const configObj = {
			amount: this.transferRequest?.amount || 0,
			accountNumber: this.form?.value?.accountNo || "1234567889",
			context: 'DEPOSIT',
			contractCode: this.transferRequest?.contractCode,
			isMobile: this.isMobile,
			btnText: 'Confirm'
		};
		config.nzComponentParams.data = configObj;

		config.nzComponentParams.callback = (result) => {
			//empty function
		};
		this.runningModal = this.modal.createModal(AddBeneficiaryComponent, config);
	}

	buildParams(beneficiaryDetails) {
		const params = {
			accountNumber: beneficiaryDetails?.accountNo,
			bankCode: beneficiaryDetails?.recipientBankCode,
			name: beneficiaryDetails?.recipientAccountName
		}
		return params;
	}

	savebeneficiary(beneficiaryDetails) {
		this.error_message = null;
		this.transferService
			.addBeneficiary(this.buildParams(beneficiaryDetails))
			.then((res) => {
				const data: any = {};
				data.isMobile = this.isMobile;
				data.messageType = DialogMessageType.SUCCESS;
				data.modalBody = '';
				data.modalTitle = `Beneficiary Saved Successfully`;
				this.launchResultModal(data);
			})
			.catch((error) => {
				this.error_message = StringHelper.getErrorMessageHttpErrorResponse(error);
				const data: any = {};
				data.isMobile = this.isMobile;
				data.messageType = DialogMessageType.FAILURE;
				data.modalBody = '';
				data.modalTitle = this.error_message;
				this.launchResultModal(data);
			});
	}

	launchResultModal(data) {
		const config = new ModalOptionsConfig();
		config.nzClosable = false;
		config.nzMaskClosable = false;
		config.nzCentered = false;
		config.nzComponentParams.data = data;
		config.nzComponentParams.callback = (result) => {
			this.runningModal.destroy();
			if (this.error_message == null) {
				this.goBack();
			}

		};
		this.runningModal = this.modal.createModal(PlainResultModalComponent, config);
	}

	deleteBeneficiary(beneficiary) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'delete';
		config.nzComponentParams.title = 'Delete Beneficiary';
		config.nzComponentParams.message = 'Are you sure you want to delete ' + beneficiary?.beneficiaryName + ' from your saved beneficiary?';
		config.className = DEFAULT_DIALOG_CLASSES;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.MONIEPOINT_V2;
		config.nzComponentParams.callbackName = 'Delete';
		config.nzComponentParams.callback = () => {
			this.deleteBeneficiaryById(beneficiary?.id);
		};
		config.nzComponentParams.cancelName = 'Cancel';
		config.nzComponentParams.cancelCallback = () => {
			this.runningModal.destroy();
		};
		this.runningModal = this.modal.alert(config);
	}

	deleteBeneficiaryById(id) {
		this.transferService
			.deleteBeneficiary(id)
			.then((res) => {
				this.runningModal.destroy();
				if (res?.code == '20000') {
					this.launchAlertModal('success', 'Delete Beneficiary', 'Beneficiary deleted successfully!');
					const index = this.beneficiaries.findIndex(item => item.id == id);
					this.beneficiaries.splice(index, 1);
				}
				else {
					this.error_message = res?.errors;
					this.launchAlertModal('error', 'Delete Beneficiary', this.error_message);
				}

			})
			.catch((error) => {
				this.error_message = StringHelper.getErrorMessageHttpErrorResponse(error);
				this.runningModal.destroy();
				this.launchAlertModal('error', 'Delete Beneficiary', this.error_message);
			});
	}

	launchAlertModal(type: string, title: string, message: string) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = type;
		config.nzComponentParams.title = title;
		config.nzComponentParams.message = message;
		config.className = DEFAULT_DIALOG_CLASSES;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.MONIEPOINT_V2;
		this.runningModal = this.modal.alert(config);
	}
}
